export default __webpack_public_path__ + "static/media/youtubeIcon.8c0fbac4.svg";